module.exports = __webpack_public_path__ + "static/media/doctors-bg.a6724a46.png";